/**
 * Available API keys for cost types
 * Grouped by data source/dataset
 */

export type CostApiKey = {
  key: string;
  label: string;
};

export type CostApiKeyGroup = {
  label: string;
  datasets: string[];
  keys: CostApiKey[];
};

export const COST_API_KEYS: Record<string, CostApiKeyGroup> = {
  morningstar: {
    label: "Morningstar (Funds & ETFs)",
    datasets: ["morningstar_funds", "morningstar_etf"],
    keys: [
      { key: "OngoingCostActual", label: "Ongoing Cost (Actual)" },
      { key: "OngoingCostEstimated", label: "Ongoing Cost (Estimated)" },
      { key: "TransactionFeeActual", label: "Transaction Fee (Actual)" },
      { key: "TransactionFeeEstimated", label: "Transaction Fee (Estimated)" },
      { key: "PerformanceFeeActual", label: "Performance Fee (Actual)" },
      { key: "PerformanceFeeEstimated", label: "Performance Fee (Estimated)" },
      { key: "MaximumEntryCostAcquired", label: "Maximum Entry Cost" },
      { key: "MaximumExitCostAcquired", label: "Maximum Exit Cost" },
      { key: "ManagementFeeExDistFeeActual", label: "Management Fee (Actual)" },
      {
        key: "ManagementFeeExDistFeeEstimate",
        label: "Management Fee (Estimated)",
      },
      {
        key: "DistributionFeePercOfNAVActual",
        label: "Distribution Fee (Actual)",
      },
      {
        key: "DistributionFeePercOfNAVEstimated",
        label: "Distribution Fee (Estimated)",
      },
    ],
  },
  eodhd: {
    label: "EODHD",
    datasets: ["eodhd"],
    keys: [
      { key: "ongoing_charge", label: "Ongoing Charge" },
      { key: "net_expense_ratio", label: "Net Expense Ratio" },
    ],
  },
};

/**
 * Get the label for a specific API key
 */
export function getCostApiKeyLabel(key: string): string {
  for (const group of Object.values(COST_API_KEYS)) {
    const found = group.keys.find((k) => k.key === key);
    if (found) return found.label;
  }
  return key;
}
